<template>
  <main id="main-content" class="container-fluid">
    <slot />
  </main>
</template>
<script>
export default {
  name: "LayoutAdminDefault"
};
</script>